import { render } from "./partD.vue?vue&type=template&id=f2074aa8"
import script from "./partD.vue?vue&type=script&lang=js"
export * from "./partD.vue?vue&type=script&lang=js"

import "./partD.vue?vue&type=style&index=0&id=f2074aa8&lang=css"

import exportComponent from "C:\\WorkSpace\\webapp\\vue3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__